import React, { useCallback, useEffect, useMemo, useState } from 'react'
import TopSection from '../../../LT/TopSection'
import DataDetails from './DataDetails'
import { Loader } from '../../../../components/common/Loader'
import ButtonComponent from '../../../../components/common/button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { postUpdateContractData } from '../../../../redux/actions/ContractMaintenance/UpdateContract'
import { addUpdateContractEndpoint, postDuplicateContractEndpoint, postSaveContractEndpoint, postSubmitContractMaintenanceEndpoint, postUpdateContractDataEndpoint, putDeleteContractEndpoint } from '../../../../common/endpoints'
import { postSaveContractData } from '../../../../redux/actions/ContractMaintenance/SaveContracts'
import { toast } from 'react-toastify'
import { addUpdateContractData } from '../../../../redux/actions/ContractMaintenance/AddContracts'
import { postSubmitContractMaintenance } from '../../../../redux/actions/ContractMaintenance/SubmitContractMaintenance'
import { duplicateContractData } from '../../../../redux/actions/ContractMaintenance/DuplicateContracts'
import { putDeleteContractData } from '../../../../redux/actions/ContractMaintenance/DeleteContracts'
import { setSelectedItem } from '../../../../redux/actions/SupportTicket/selectionSlice'

const UpdateContract = () => {
  const dispatch = useDispatch();
  const [rowsData, setRowsData] = useState([]);
  const [btnDisabled, setIsBtnDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [getAllMaintenanceData, setGetAllMaintenanceData] = useState([]);
  const [isDeleteBtnDisable, setIsDeleteBtnDisable] = useState(true);
  const [seqIds, setSeqIds] = useState([]);

  const userEmail = localStorage.getItem("data");
  const userName = localStorage.getItem("userName");
  const userRole = localStorage.getItem("CDRole");

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };

  const postUpdateContractMaintenanceData = useSelector((state) => state?.postUpdateContractDataSlice?.data);

  const pagination = true;
    const paginationPageSize = 50;
    const paginationPageSizeSelector = [50, 100, 200, 500, 2000];

    const handleCellValueChange = (params) => {
      if (rowsData.some(row => row.uniqueRowId === params.data.uniqueRowId)) {
        const updatedSelectedRows = rowsData.map(row =>
          row.uniqueRowId === params.data.uniqueRowId ? params.data : row
        );
        setRowsData(updatedSelectedRows);
      }
    }

    const onSelectionChanged = (params) => {
      const selectedRowsOnCurrentPage = [];
      const currentPage = params.api.paginationGetCurrentPage();
      const pageSize = params.api.paginationGetPageSize();
      let index = 0;

      params.api.forEachNodeAfterFilterAndSort((node) => {
        const nodePage = Math.floor(index / pageSize);
        if (nodePage === currentPage && node.isSelected()) {
          selectedRowsOnCurrentPage.push(node.data);
        }
        index++;
      });

      setRowsData(selectedRowsOnCurrentPage);
      dispatch(setSelectedItem(selectedRowsOnCurrentPage));

      const ids = selectedRowsOnCurrentPage?.map(item => item?.contractSeqId);
      setSeqIds(ids);

      const hasInvalidSeqId = selectedRowsOnCurrentPage.some((row) => !row.contractSeqId || row.contractSeqId === ""); 
      setIsDeleteBtnDisable(selectedRowsOnCurrentPage.length === 0 || hasInvalidSeqId);
      setIsBtnDisabled(selectedRowsOnCurrentPage.length === 0);
    };
  
    // const onSelectionChanged = (params) => {
    //   const displayedRows = [];
    //   params.api.forEachNodeAfterFilterAndSort((node) => {
    //     console.log(node.data, 'node.data')
    //     if(node.isSelected()) {
    //       displayedRows.push(node.data);
    //     }
    //   });
    
    //   const startIndex = (params.api.paginationGetCurrentPage() * params.api.paginationGetPageSize());
    //   const endIndex = startIndex + params.api.paginationGetPageSize();
    //   const rowsInCurrentPage = displayedRows.slice(startIndex, endIndex);

    //   const selectedRows = rowsInCurrentPage.filter((row) =>
    //     params.api.getSelectedNodes().some((node) => node.data === row)
    //   );
    //   setRowsData(selectedRows);
    //   dispatch(setSelectedItem(selectedRows));

    //   const ids = selectedRows?.map(item => item?.contractSeqId);
    //   setSeqIds(ids);

    //   const hasInvalidSeqId = selectedRows.some((row) => !row.contractSeqId || row.contractSeqId === ""); 
    //   if (selectedRows.length === 0 || hasInvalidSeqId) {
    //     setIsDeleteBtnDisable(true);
    //   } else {
    //     setIsDeleteBtnDisable(false);
    //   }

    //   selectedRows?.length ? setIsBtnDisabled(false) : setIsBtnDisabled(true);
    // };
    
    const rowSelection = useMemo(() => {
      return {
        mode: "multiRow",
        isRowSelectable: (rowNode) =>
          rowNode.data && userRole !== "Viewer"
            ? true
            : false,
      };
    }, [userRole]);

  const duplicateContractHandler = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        duplicateContractData({
          dynamicEndpoint: `${postDuplicateContractEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}&cmType=UPDATE`,
          data: rowsData
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        await callSameFilterApi();
        toast.success(response.payload.cmDuplicateResponseDTO.message, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true);
        setIsDeleteBtnDisable(true);
      } else {
        setIsLoading(false)
        toast.error(response.payload.errorMessage, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true)
        setIsDeleteBtnDisable(true);
      }
    } catch (error) {
      console.error("Error saving contracts maintenance data:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const addContractMaintenanceHandler = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        addUpdateContractData({
          dynamicEndpoint: `${addUpdateContractEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}&cmType=UPDATE`,
          data: rowsData
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        await callSameFilterApi();
        toast.success(response.payload.cmAddResponseDTO.message, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true);
        setIsDeleteBtnDisable(true);
      } else {
        setIsLoading(false)
        toast.error(response.payload.errorMessage, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true)
        setIsDeleteBtnDisable(true);
      }
    } catch (error) {
      console.error("Error saving contracts maintenance data:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const deleteContractMaintenanceHandler = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        putDeleteContractData({
          dynamicEndpoint: `${putDeleteContractEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}`,
          data: {
            contractSeqIds: seqIds,
          }
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        await callSameFilterApi();
        toast.success(`Contract Line item change Deleted`, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true);
        setIsDeleteBtnDisable(true);
      }
    } catch (error) {
      console.error("Error saving contracts maintenance data:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const saveContractsMaintenanceHandler = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        postSaveContractData({
          dynamicEndpoint: `${postSaveContractEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}&cmType=UPDATE`,
          data: rowsData
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        await callSameFilterApi();
        toast.success(response.payload.cmSaveDTO.message, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true);
        setIsDeleteBtnDisable(true);
      } else {
        setIsLoading(false)
        toast.error(response.payload.errorMessage, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true)
        setIsDeleteBtnDisable(true);
      }
    } catch (error) {
      console.error("Error saving contracts maintenance data:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleContractSubmit = async () => {
      setIsLoading(true);
        try {
          const response = await dispatch(
            postSubmitContractMaintenance({
              dynamicEndpoint: `${postSubmitContractMaintenanceEndpoint}?userName=${cleanUsername(userName)}&cmType=UPDATE&userEmailList=${userEmail}`,
              data: rowsData
            })
          );
          if (response.meta.requestStatus === "fulfilled") {
            await callSameFilterApi();
            toast.success(response.payload, {
              autoClose: 2000,
            });
            setIsBtnDisabled(true);
            setIsDeleteBtnDisable(true);
          } else {
            setIsLoading(false)
            toast.error(response.payload, {
              autoClose: 2000,
            });
            setIsBtnDisabled(true)
            setIsDeleteBtnDisable(true)
          }
        } catch (error) {
          console.error("Error saving contracts maintenance data:", error);
        } finally {
          setIsLoading(false);
        }
    }

  const callSameFilterApi = useCallback(async () => {
      setIsLoading(true);
      const stored = localStorage.getItem("contractMaintenancePostUpdateFilterData");
      if (stored) {
        const filterData = JSON.parse(stored);
        try {
          const response = await dispatch(
            postUpdateContractData({
              dynamicEndpoint: `${postUpdateContractDataEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}`,
              data: {
                ...filterData,
              }
            })
          );
          if (response.meta.requestStatus === "fulfilled") {
            setGetAllMaintenanceData(response.payload);
          }
        } finally {
          setIsLoading(false);
        }
      }
    }, [dispatch, userEmail, userName]);
  
    useEffect(() => {
      callSameFilterApi();
    }, [callSameFilterApi]);

  return (
    <>
        <TopSection
            labelList={[
            { title: "Home", path: "/landing-page" },
            { title: "Contract Maintenance", path: "/contract-maintenance" },
            { title: "Update Contract" },
            ]}
            hideHeader={true}
            headerName={"Update Contract"}
        />
        <div className="priceMemo_dataTable">
          {isLoading ? (
            <Loader />
          )
          :
            <DataDetails
              rowData={postUpdateContractMaintenanceData?.cmMaintenanceView || getAllMaintenanceData}
              pagination={pagination}
              paginationPageSize={paginationPageSize}
              paginationPageSizeSelector={paginationPageSizeSelector}
              onSelectionChanged={onSelectionChanged}
              rowSelection={rowSelection}
              handleCellValueChange={handleCellValueChange}
              setRowsData={setRowsData}
              selectedRowsData={rowsData}
              userRole={userRole}
            />
          }
            {
              userRole !== "Viewer" && (
                <div
                  style={{
                    marginTop: "50px",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "30px",
                  }}
                >
                  <div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "400px",
                    }}
                  >
                    <ButtonComponent
                      label="Duplicate"
                      bgColor="#000"
                      color="#fff"
                      disabled={btnDisabled}
                      onClick={duplicateContractHandler}
                    />
                    <ButtonComponent
                      label="Add"
                      bgColor="#000"
                      color="#fff"
                      disabled={btnDisabled}
                      onClick={addContractMaintenanceHandler}
                    />
                    <ButtonComponent
                      label="Delete"
                      bgColor="#000"
                      color="#fff"
                      disabled={isDeleteBtnDisable}
                      onClick={deleteContractMaintenanceHandler}
                    />
                    <ButtonComponent
                      label="Save"
                      bgColor="#000"
                      color="#fff"
                      disabled={btnDisabled}
                      onClick={saveContractsMaintenanceHandler}
                    />
                    <ButtonComponent
                      label="Submit"
                      bgColor="#000"
                      color="#fff"
                      onClick={handleContractSubmit}
                      disabled={btnDisabled}
                    />
                  </div>
                </div>
              )
            }
            
          </div>
    </>
  )
}

export default UpdateContract